import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import ResetPassword from "./auth/resetpwd/reducer"
import { ForgetPasswordResendCode } from "./auth/forgetpwd/reducer"

import Clients from "./clients/getclients/reduces"
import AddClient01 from "./clients/addclient/reducer"
import ClientStatus from "./clients/clientstatus/reducer"
//Dashboard 
import Dashboard, { GetCounts, GetRecentQuotes, GetPieChart, GetBarChart } from "./dashboard/reducer";
//Dasboard saas
import DashboardSaas from "./dashboard-saas/reducer"
//Admin
import GetAdmin, { GetAdminRoles } from "./admin/getAdmin/reducer"
import AddAdmin from "./admin/addAdmin/reducer"
import GetAdminById from "./admin/getAdminById/reducer"
import changeStatus from "./admin/Activate--De-Activate/reducer"
//User
import GetUser from './user/getUser/reducer'
import AddUser from "./user/addUser/reducer"
import GetUserById from "./user/getUserById/reducer"
import DeleteUser from "./user/deleteUser/reducer"
//booking
import GetAllBookings, { TrackBookings, GetByBookingNo, GetBookingBYContainerWise } from "./booking/getBooking/reducer"
//quotes
import AddQuotesSeaExportGeneralCargo, { GetQuotes, GetQuoteById, DeleteQuote, QuoteStatusUpdate, AddAirShipperInfo, GetAirShipperInfo, AddSeaShipperInfo, GetSeaShipperInfo, AirShipperInfoStatusUpdate, SeaShipperInfoStatusUpdate } from "./quotes/reducer"
//generate password
import { GeneratePasswordReducer } from "./user/deleteUser/reducer"
//profile
import { UpdateProfile, LoginPasswordChange, UpdateProfileImg } from './profile/reducer'
// settings
import SettingsUpdate, { GetSettings, GetNotification} from "./settings/reducer"

import ErrorScreenCode from "./errorscreen/reducer" 

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Dashboard,
  DashboardSaas,
  Clients,
  AddClient01,
  GetAdmin,
  AddAdmin,
  GetAdminById,
  changeStatus,
  GetUser,
  AddUser,
  GetUserById,
  ResetPassword,
  DeleteUser,
  ClientStatus,
  GetAdminRoles,
  GetAllBookings,
  AddQuotesSeaExportGeneralCargo,
  GetQuotes,
  ForgetPasswordResendCode,
  GetQuoteById,
  GeneratePasswordReducer,
  GetCounts,
  GetRecentQuotes,
  GetPieChart,
  GetBarChart,
  UpdateProfile,
  LoginPasswordChange,
  DeleteQuote,
  TrackBookings,
  UpdateProfileImg,
  QuoteStatusUpdate,
  GetByBookingNo,
  GetBookingBYContainerWise,
  SettingsUpdate,
  GetSettings,
  ErrorScreenCode,
  AddAirShipperInfo,
  GetAirShipperInfo,
  AddSeaShipperInfo,
  GetSeaShipperInfo,
  AirShipperInfoStatusUpdate,
  SeaShipperInfoStatusUpdate,
  GetNotification
})

export default rootReducer
